<div class="map-container" #mapContainer>
</div>

<div *ngIf="contextMenuVisible" class="map-context-menu"
  [ngStyle]="{ top: contextMenuY + 'px', left: contextMenuX + 'px' }">
  <button type="button" (click)="createHeroReportFromCoordinates()">
    Create Hero Report
  </button>
  <button type="button" (click)="createSreReportFromCoordinates()" i18n="@@mapContextMenu.createSreReport">
    Create SRE Report
  </button>
</div>
